<!-- Horizontal Bar Chart Starts -->
<div class="row" *ngIf="currentUrl ==='course-reports'">
    <div class="col-sm-12">
        <div class="card">
            <div class="container d-flex">
                <div class="col-6 card-header">
                    <h4 class="card-title">Enrollment Report</h4>
                </div>
                <div class="col-6">
                    <div class="d-flex justify-content-end">
                        <div class="col-flex-2 mt-3 mr-1">
                            <ng-select class="mr-2" (click)="$event.stopPropagation()" style="width: 146px;" [items]="months"  [searchable]="false"
                            [clearable]="false" bindLabel="label" bindValue="value" placeholder="Select month"
                            [(ngModel)]="selectedMonth" (change)="getReports()"  >
                        </ng-select>
                        </div>
                        <div class="col-flex-2 mt-3">
                            <ng-select  (click)="$event.stopPropagation()" style="width: 85px;" [items]="yearsList" [searchable]="false"
                                [clearable]="false" placeholder="Select year"
                                [(ngModel)]="selectedYear" (change)="getReports()"  >
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div class="card-content">
                <div class="card-body">
                    <div id="horizontal-bar-chart" class="height-400">
                        <ngx-charts-bar-horizontal-2d [scheme]="barChartColorScheme" [results]="barChartmulti" [gradient]="barChartGradient" [xAxis]="barChartShowXAxis"
                            [yAxis]="barChartShowYAxis" [legend]="barChartShowLegend" [showXAxisLabel]="barChartShowXAxisLabel"
                            [showYAxisLabel]="barChartShowYAxisLabel" [xAxisLabel]="barChartXAxisLabel" [yAxisLabel]="barChartYAxisLabel"
                            (select)="onSelect($event)">
                        </ngx-charts-bar-horizontal-2d>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
<div class="row" *ngIf="currentUrl ==='course-reports2'">
    <div class="col-sm-12">
        <div class="card">
            <div class="container d-flex">
                <div class="col-6 card-header">
                    <h4 class="card-title">Enrollment Report</h4>
                </div>
                <div class="col-6">
                    <div class="d-flex justify-content-end">
                        <div class="col-flex-2 mt-3 mr-1">
                            <ng-select class="mr-2" (click)="$event.stopPropagation()" style="width: 146px;" [items]="months"  [searchable]="false"
                            [clearable]="false" bindLabel="label" bindValue="value" placeholder="Select month"
                            [(ngModel)]="selectedMonth" (change)="getReports()"  >
                        </ng-select>
                        </div>
                        <div class="col-flex-2 mt-3">
                            <ng-select  (click)="$event.stopPropagation()" style="width: 85px;" [items]="yearsList" [searchable]="false"
                                [clearable]="false" placeholder="Select year"
                                [(ngModel)]="selectedYear" (change)="getReports()"  >
                            </ng-select>
                        </div>
                    </div>
                </div>
            </div>
            
            
            <div class="card-content">
                <div class="card-body">
                    <div id="horizontal-bar-chart" class="height-400">
                        <ngx-charts-bar-horizontal-2d [scheme]="barChartColorScheme" [results]="barChartmulti" [gradient]="barChartGradient" [xAxis]="barChartShowXAxis"
                            [yAxis]="barChartShowYAxis" [legend]="barChartShowLegend" [showXAxisLabel]="barChartShowXAxisLabel"
                            [showYAxisLabel]="barChartShowYAxisLabel" [xAxisLabel]="barChartXAxisLabel" [yAxisLabel]="barChartYAxisLabel"
                            (select)="onSelect($event)">
                        </ngx-charts-bar-horizontal-2d>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
 <!--/ Filter Datatables -->
 <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>